import React from "react";
import { AbsoluteFill } from "../AbsoluteFill";
 
export const Star = () => {
  return (
    <AbsoluteFill
      style={{
        justifyContent: "center",
        alignItems: "center",
        fontSize: 14,
      }}
    >
      ⭐
    </AbsoluteFill>
  );
};